import * as THREE     from 'three'
import Scene          from './Scene'
import FBXLoader      from '../vendor/three-loaders/FBXLoader'
import CameraControls from 'camera-controls'

CameraControls.install( { THREE: THREE } )

class SceneObjectView extends Scene {

  constructor(props) {
    super(props)

    this.cameraControls = null
    this.cameraControlsClock = new THREE.Clock()
  }

  beforeRenderSceneLoop() {
    this.disableControls()
    this.initOrbitControls()
  }

  initOrbitControls() {
    this.camera.lookAt( new THREE.Vector3() )
    this.cameraControls = new CameraControls(this.camera, this.renderer.domElement)
  }

  sceneLoopUpdate(time) {
    const delta = this.cameraControlsClock.getDelta()
    if (this.cameraControls) {
      const hasControlsUpdated = this.cameraControls.update(delta)
    }

    super.sceneLoopUpdate(time)
  }

  loadModels() {
    let fbxLoader = new FBXLoader(this.loadingManager)
    fbxLoader.load(
      this.config.model.path,
      object => {

        this.onModelObjectLoad(object, this.config.model, (group) => {
          if (this.cameraControls) {
            this.cameraControls.fitTo( group, true, { paddingTop: 10, paddingLeft: 10, paddingBottom: 10, paddingRight: 10 } )
          }
        })
      },
      data => this.onModelObjectLoadProgress(data),
      error => this.onModelObjectLoadError(error)
    )
  }

  onModelObjectLoad(object, data = null, onComplete) {
    if (!!data) {
      window.Logger.log('MODEL OBJECT LOAD', data.name)
    }
    window.setTimeout(() => {
      this.processModelObject(object, data, onComplete)
    }, 0)
  }

  processModelObject(object, data = null, onComplete) {
    let shiftGroup = new THREE.Group()
    if (data && data.name) {
      shiftGroup.name = data.name
    }
    shiftGroup.add(object)
    object.position.set(0, 0, 0)

    if (data && data.position) {
      shiftGroup.position.set(data.position.x, data.position.y, data.position.z)
    }
    if (data && data.rotation) {
      shiftGroup.rotation.set(
        THREE.Math.degToRad(data.rotation.x),
        THREE.Math.degToRad(data.rotation.y),
        THREE.Math.degToRad(data.rotation.z)
      )
    }

    if (data.scale) {
      shiftGroup.scale.setScalar(data.scale)
    }

    if (data.correction) {
      // reposition geometry got from file,
      // this is needed if object in file is not centered properly

      if (data.correction.position) {
        object.position.copy(new THREE.Vector3(
          data.correction.position.x,
          data.correction.position.y,
          data.correction.position.z
          )
        )
      }

      if (data.correction.rotation) {
        object.rotation.set(
          THREE.Math.degToRad(data.correction.rotation.x),
          THREE.Math.degToRad(data.correction.rotation.y),
          THREE.Math.degToRad(data.correction.rotation.z)
        )
      }
    }

    if (data.aoMap) {
      //object.material.aoMap = new THREE.TextureLoader().load(data.aoMap)
      object.traverse(child => {
        if (child.isMesh) {
          if (child.geometry.attributes.uv !== undefined) {
            child.geometry.attributes.uv2 = child.geometry.attributes.uv.clone()
          }
        }
      })

      new THREE.TextureLoader().load(data.aoMap, (texture) => {
        shiftGroup.traverse(child => {
          if (child.isMesh) {
            if (child.material.length) {
              child.material.forEach(function (material) {
                material.aoMap = texture
                material.needsUpdate = true
                if (material.map !== null) {
                  material.color.setRGB(1, 1, 1)
                }
              })
            } else {
              child.material.aoMap = texture
              child.material.needsUpdate = true
            }
          }
        })
      })
    }

    // this.scene.add(new THREE.GridHelper(400, 4))
    // this.scene.add(new THREE.AxesHelper(50))
    // shiftGroup.add(new THREE.AxesHelper(25))

    this.scene.add(shiftGroup)

    if (typeof onComplete === 'function') {
      onComplete(shiftGroup)
    }
  }

  onModelObjectLoadProgress(xhr, data = null) {
    // window.Logger.log('MODEL OBJECT PROGRESS', (data ? data.id + ' ' + data.name : null))
    // if (xhr.lengthComputable) {
    //   window.Logger.log(Math.round(xhr.loaded / xhr.total * 100) + '% is loaded.')
    // }
  }

  onModelObjectLoadError(error, data = null) {
    if (data) {
      window.Logger.error('DATA: ', data)
    }

    throw new Error('MODEL OBJECT ERROR: ' + error)
  }
}

export default SceneObjectView
